import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// Redirect helper for legacy /preview/blog/:slug URLs.
// Preserves the slug so ranking + inbound links continue resolving.
const BlogRedirect = () => {
  const { slug } = useParams();
  return <Navigate to={slug ? `/blog/${slug}` : '/blog'} replace />;
};

export default BlogRedirect;
